import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import {
  Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input, Stack, Textarea,
} from "@/components/ui";
import { useCrearFlujo } from "../../hooks/use-notificaciones";

/** Alta de un flujo · al crearlo abre directamente su diseñador. */
export function CrearFlujoDialog({ abierto, onCerrar }: { abierto: boolean; onCerrar: () => void }) {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const crear = useCrearFlujo({
    onCreado: (id) => {
      onCerrar();
      void navigate({ to: "/admin/notificaciones/$id", params: { id } });
    },
  });
  const valido = nombre.trim().length > 0 && nombre.trim().length <= 150;

  return (
    <Dialog open={abierto} onOpenChange={(o) => (!o ? onCerrar() : undefined)}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Nuevo flujo de notificaciones</DialogTitle>
          <DialogDescription>Agrupa eventos y las notificaciones que disparan (p. ej. "Altas de proveedores").</DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (valido) crear.mutate({ nombre: nombre.trim(), descripcion: descripcion.trim() || null });
          }}
        >
          <Stack gap="md">
            <Input label="Nombre" required maxLength={150} value={nombre} onChange={(e) => setNombre(e.target.value)} autoFocus />
            <Textarea label="Descripción" maxLength={1000} rows={3} value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
          </Stack>
          <DialogFooter className="mt-6">
            <Button type="button" variant="default" onClick={onCerrar}>Cancelar</Button>
            <Button type="submit" disabled={!valido} loading={crear.isPending}>Crear y diseñar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
